// extracted by mini-css-extract-plugin
export var cardHeader = "_fc-0";
export var reorderHandle = "_fc-3";
export var titleArea = "_fc-1";
export var titleAreaWithHandle = "_fc-2";